<template>
  <div id="modelFilterList">
    <div class="shown-toolbar form-group">
      <label class="control-label sr-only">URL Builder</label>
      <textarea id="url-builder" @focus="selectUrl()" class="form-control" :value="urlBuilder"></textarea>
    </div>

    <div id="filter-toggle" class="toggle-filters margin-bottom visible-xs"><a @click="toggleFilters()" class="btn-gradient">Open Filters</a></div>

    <div id="search-filters-wrapper" class="search-filters">
      <fieldset class="model-filter-wrapper category-list-wrapper" v-if="categoryOptions && categoryOptions.length">
        <legend>Filter By Category</legend>
        <div class="category-options options-wrapper">
          <select v-model="searchCategoryFilter" class="form-control">
            <option value="">Select One</option>
            <option v-for="(option) in categoryOptions" :key="option.id" :value="option.id">{{ option.name }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper onlineonly-list-wrapper">
        <legend>Filter By Availability</legend>
        <div class="onlineonly-options options-wrapper">
          <div class="option">
            <label>
              <input type="checkbox" v-model="searchOnlineOnlyFilter" value="1" />
              Available For Online Order
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper brand-list-wrapper" v-if="brandOptions && brandOptions.length">
        <legend>Filter By Brand</legend>
        <div class="brand-options options-wrapper">
          <div v-for="(option) in brandOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchBrandFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper type-list-wrapper" v-if="typeOptions && typeOptions.length">
        <legend>Filter By Type</legend>
        <div class="type-options options-wrapper">
          <div v-for="(option) in typeOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchTypeFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper industry-list-wrapper" v-if="industryOptions && industryOptions.length">
        <legend>Filter By Industry</legend>
        <div class="industry-options options-wrapper">
          <div v-for="(option) in industryOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchIndustryFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper size-list-wrapper" v-if="sizeOptions && sizeOptions.length">
        <legend>Filter By Size</legend>
        <div class="size-options options-wrapper">
          <div v-for="(option) in sizeOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchSizeFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper btu-list-wrapper" v-if="btuOptions && btuOptions.length">
        <legend>Filter By BTU Per Hour</legend>
        <div class="btu-options options-wrapper">
          <div v-for="(option) in btuOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchBtuFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
  name: 'SearchFilters',
  props: {
    categoryFilter: Array,
    brandFilter: Array,
    typeFilter: Array,
    industryFilter: Array,
    sizeFilter: Array,
    btuFilter: Array,
    onlineOnlyFilter: Boolean,
    categoryOptions: Array,
    brandOptions: Array,
    typeOptions: Array,
    industryOptions: Array,
    sizeOptions: Array,
    btuOptions: Array,
    urlBuilder: String
  },
  setup (props, { emit }) {
    return {
      searchCategoryFilter: useModelWrapper(props, emit, 'categoryFilter'),
      searchBrandFilter: useModelWrapper(props, emit, 'brandFilter'),
      searchTypeFilter: useModelWrapper(props, emit, 'typeFilter'),
      searchIndustryFilter: useModelWrapper(props, emit, 'industryFilter'),
      searchSizeFilter: useModelWrapper(props, emit, 'sizeFilter'),
      searchBtuFilter: useModelWrapper(props, emit, 'btuFilter'),
      searchOnlineOnlyFilter: useModelWrapper(props, emit, 'onlineOnlyFilter')
    }
  },
  methods: {
    toggleFilters: function () {
      var button = document.getElementById('filter-toggle').getElementsByClassName('btn-gradient')[0]
      var filters = document.getElementById('search-filters-wrapper')
      if (button.innerHTML === 'Open Filters') {
        button.innerHTML = 'Close Filters'
        filters.style.height = filters.scrollHeight + 'px'
      } else {
        button.innerHTML = 'Open Filters'
        filters.style.height = '0px'
      }
    },
    selectUrl: function () {
      document.getElementById('url-builder').select()
    }
  }
}
</script>
